import { NewQuestionActionTypes } from './new-question.types';

export const toggleNewQuestionPageHidden = () => ({
    type: NewQuestionActionTypes.TOGGLE_QUESTION_PAGE_HIDDEN
});